<template>
    <div>
        <div class="overflow-hidden w-[92%] sm:w-4/5 max-w-[45.5rem] mx-auto pt-3">
            <h2 class="text-black font-black text-xl">
                請設定帳號及密碼
            </h2>
        </div>
        <div
            class="rounded-t-md rounded-b-lg bg-white pb-[2.5rem] overflow-hidden w-[92%] sm:w-4/5 max-w-[45.5rem] mx-auto shadow-1 border border-gray-100"
        >
            <div class="text-black text-center px-4 pt-6">
                <p>未來您可以此帳號及密碼</p>
            </div>
            <div class="text-black text-center px-4">
                <p>登入富邦人壽保戶會員專區查詢您的保單資料</p>
            </div>
            <div class="border-t w-[85%] max-w-[34rem] mx-auto mt-6 pt-6">
                <div class="mb-4 flex flex-col md:flex-row md:items-center md:justify-end">
                    <div class="flex flex-col md:flex-row md:items-center mr-4">
                        <label class="text-lg mr-2 my-1 flex-shrink-0">
                            帳號
                        </label>
                    </div>
                    <div class="flex flex-col">
                        <div class="mb-4">
                            <div class="flex flex-col md:flex-row md:items-center md:justify-end mr-5">
                                <label class="label justify-start p-0 text-base xs:text-lg w-fit">
                                    <input
                                        v-model="accountType"
                                        type="radio"
                                        name="name"
                                        class="radio"
                                        value="1"
                                    >
                                    <div
                                        class="text-gray-700 w-full items-center flex-shrink-0 relative"
                                    >
                                        <label class="text-lg mr-2 my-1 flex-shrink-0">
                                            同意以身分證號碼(統一證號)為日後登入帳號
                                        </label>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <InputTypes
                            v-model:value="account"
                            type="password"
                            :errorMsg="errors.account"
                            :disabled="accountType==='1'"
                            placeholder="長度6至12碼，請勿使用特殊符號"
                        >
                            <template #label>
                                <label class="label w-full justify-start p-0 text-base xs:text-lg w-fit min-w-max">
                                    <input
                                        v-model="accountType"
                                        type="radio"
                                        name="name"
                                        class="radio"
                                        value="2"
                                    >
                                    <div
                                        class="text-gray-700 w-full items-center flex-shrink-0 relative"
                                    >
                                        <label class="text-lg mr-2 my-1 flex-shrink-0">
                                            自行設定
                                        </label>
                                    </div>
                                </label>
                            </template>
                        </InputTypes>
                    </div>
                </div>
                <InputTypes
                    v-model:value="account2"
                    type="password"
                    label="帳號確認"
                    :errorMsg="errors.account2"
                    placeholder="請再次輸入，確認您的帳號"
                    @validateValue="validateAccount2"
                />
                <InputTypes
                    v-model:value="password"
                    type="password"
                    label="密碼"
                    :errorMsg="errors.password"
                    placeholder="長度8至12碼，請勿使用連續或相同4碼的文字及數字"
                    @validateValue="validatePassword"
                />
                <InputTypes
                    v-model:value="password2"
                    type="password"
                    label="密碼確認"
                    :errorMsg="errors.password2"
                    placeholder="請再次輸入，確認您的密碼"
                    @validateValue="validatePassword2"
                />

                <div class="bg-gray-100 p-4">
                    <ul class="pl-2 list-decimal">
                        <li>「帳號」須為6至12位，英文不分大小寫，且不得為他人身分證號碼(統一編號)及與他人重覆。</li>
                        <li>
                            「密碼」須為8至12位，須包括英文大小寫及數字，且不得為相同或連續之數字或英文字；不可與前次相同。
                        </li>
                        <li>「帳號」及「密碼」不可相同。</li>
                        <li>「密碼」不得為「身分證字號」或「生日」</li>
                        <li>「帳號」及「密碼」不得有空白鍵及特殊字元。</li>
                        <li>密碼範例說明：Fubon168</li>
                    </ul>
                </div>

                <div class="flex items-center justify-center mt-2">
                    <button
                        class="btn rounded-full btn-accent border-0 max-w-[8.75rem] mb-6"
                        @click.prevent="cancel"
                    >
                        取消申請
                    </button>
                    <button
                        class="btn rounded-full gradient-primary border-0 max-w-[8.75rem] mb-6"
                        @click.prevent="validValue"
                    >
                        確定
                    </button>
                </div>
            </div>
        </div>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { reactive, ref, toRefs, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import InputTypes from '@/components/inputs/InputTypes.vue';
import { textLength } from '@/utils/rules/customRules';
import { postEncrypt, postRegister } from '@/apis/eNotifyPromo';
import routeName from '@/router/constant.js';
import { openPopupCatchMessage } from '@/utils/vfmUtils';

export default {
    components: {
        InputTypes,
    },
    setup() {
        const router = useRouter();
        const store = useStore();
        const isLoading = ref(false);
        const data = reactive({
            account: '',
            account2: '',
            password: '',
            password2: '',
            accountType: '1',
            errors: {
                account: '',
                account2: '',
                password: '',
                password2: '',
            },
        });

        const validateAccount = (value) => {
            const { message } = textLength({
                value,
                min: 6,
                fieldName: '帳號',
            });
            data.errors.account = message;
        };

        const validateAccount2 = (value) => {
            const { message } = textLength({
                value,
                min: 6,
                fieldName: '帳號確認',
            });
            if (message === '' && data.accountType === '2' && data.account !== value) {
                data.errors.account2 = '與帳號不相符';
            } else {
                data.errors.account2 = message;
            }
        };

        const validatePassword = (value) => {
            const { message } = textLength({
                value,
                min: 8,
                fieldName: '密碼',
            });
            data.errors.password = message;
        };
        const validatePassword2 = (value) => {
            const { message } = textLength({
                value,
                min: 8,
                fieldName: '密碼確認',
            });
            if (message === '' && data.password !== value) {
                data.errors.password2 = '與密碼不相符';
            } else {
                data.errors.password2 = message;
            }
        };

        const validValue = () => {
            if (data.accountType === '2') {
                validateAccount(data.account);
            }
            validatePassword(data.password);
            validateAccount2(data.account2);
            validatePassword2(data.password2);

            const {
                account,
                password,
                account2,
                password2,
            } = data.errors;

            if (account || password || account2 || password2) {
                return;
            }
            register();
        };

        const register = async () => {
            isLoading.value = true;
            const encrypPassword = await encryp(data.password);
            const encrypPassword2 = await encryp(data.password2);

            const request = {
                accountSetType: data.accountType,
                myId: data.accountType === '2' ? data.account : data.account2,
                myId2: data.account2,
                password: encrypPassword,
                password2: encrypPassword2,
            };
            postRegister(request).then((res) => {
                router.push({
                    name: routeName.FINISH,
                });
            }).catch((err) => {
                openPopupCatchMessage(err);
            }).finally(() => {
                isLoading.value = false;
            });
        };

        const encryp = (password) => {
            return postEncrypt(password).then((res) => {
                return res.data.encrypted;
            }).catch(() => {
                return password;
            });
        };

        /**
         * 取消申請
         */
        const cancel = () => {
            store.dispatch('permissions/goFubonOfficial');
        };

        watch(() => data.accountType, (nV) => {
            if (nV === '1') {
                data.account = '';
            }
        });

        return {
            ...toRefs(data),
            isLoading,
            validateAccount,
            validateAccount2,
            validatePassword,
            validatePassword2,
            validValue,
            cancel,
        };
    },
};
</script>

<style scoped>
.label {
    /* w-fit沒有效 */
    width: fit-content;
}

.radio {
    @apply w-[0.8125rem] h-[0.8125rem] md:w-[0.9375rem] md:h-[0.9375rem] border border-gray-200 mr-2;
}
</style>
